import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import { useIntl, Link } from "gatsby-plugin-intl"
import { navigate } from "gatsby"

import greenSkils from "../images/skills-green.png"
import greenArrow from "../images/arrow-green.png"
import greenCheck from "../images/check-green.png"

import redSkills from "../images/skills-red.png"
import redArrow from "../images/arrow-red.png"
import redCheck from "../images/check-red.png"

import blueSkills from "../images/skills-blue.png"
import blueArrow from "../images/arrow-blue.png"
import blueCheck from "../images/check-blue.png"

import formattingJson from "../scripts/formattingJson"
import HTMLEntities from "../scripts/HTMLEntities"

import Toc from "../components/Toc"
import ModuleBadge from "../components/ModuleBadge"
import NavLessons from "../components/NavLessons"

export default function Lessons({ data }) {
  const isBrowser = typeof window !== "undefined"

  let colors
  let questions
  const content = data.lessonsJson
  const intl = useIntl()

  if (content.type === "Quiz") {
    questions = content.questionsString[intl.locale]
      .split("[outerQuestion]")
      .map(question => question.split("[innerQuestion]"))
  }
  const checkAnswer = event => {
    document.getElementById(
      `question${event.target.dataset.questionnbr}Correct`
    ).style.display = "none"
    document.getElementById(
      `question${event.target.dataset.questionnbr}Explanation`
    ).style.display = "none"
    if (event.target.value === event.target.dataset.correct) {
      document.getElementById(
        `question${event.target.dataset.questionnbr}Correct`
      ).style.display = "block"
    } else {
      document.getElementById(
        `question${event.target.dataset.questionnbr}Explanation`
      ).style.display = "block"
    }
  }
  useEffect(() => {
    if (isBrowser && !window.localStorage[content.module]) {
      window.localStorage[content.module] = "[]"
    }
  })

  const markRead = () => {
    let arrayLocalStorage = JSON.parse(window.localStorage[content.module])
    arrayLocalStorage.push(Number(content.grainId))
    window.localStorage[content.module] = JSON.stringify(arrayLocalStorage)
    navigate("../")
  }

  const unmarkRead = () => {
    window.localStorage[content.module] = JSON.stringify(
      JSON.parse(window.localStorage[content.module]).filter(
        grain => grain !== Number(content.grainId)
      )
    )
    navigate("../")
  }

  switch (content.module) {
    case "O4":
      colors = {
        primary: "#18816b",
        secondary: "#FFF",
        icon: greenSkils,
        arrow: greenArrow,
        check: greenCheck,
        gradientLeft: "#4CA8F1",
        gradientRight: "#02D7A9",
      }
      break
    case "O5":
      colors = {
        primary: "#b05863",
        secondary: "#FFF",
        icon: redSkills,
        arrow: redArrow,
        check: redCheck,
        gradientLeft: "#724CF9",
        gradientRight: "#FF949A",
      }
      break
    case "O6":
      colors = {
        primary: "#724CF9",
        secondary: "#FFF",
        icon: blueSkills,
        arrow: blueArrow,
        check: blueCheck,
        gradientLeft: "#4CA8F1",
        gradientRight: "#724CF9",
      }
      break
    default:
  }

  return (
    <Layout>
      <Seo title={content.name[intl.locale]} lang={intl.locale} />
      <section className="goodpractices__banner">
        <div
          className="bannerGradient"
          style={{
            backgroundImage: `linear-gradient(to right, ${colors.gradientLeft}, ${colors.gradientRight})`,
          }}
        >
          <div className="bannerGradient--container">
            <div className="bannerGradient--inner">
              <p
                className="bannerGradient--smallText"
                style={{ color: `${colors.secondary}` }}
              >
                <Link to="/" style={{ color: `${colors.secondary}` }}>
                  The Good Manager
                </Link>
                &nbsp; {">"} &nbsp;
                {/* <Link to="/good-practices" className="bannerGradient--framed">{intl.formatMessage({ id: "menu8" })}</Link>
          &nbsp; > &nbsp; */}
                <Link to="/training" style={{ color: `${colors.secondary}` }}>
                  {intl.formatMessage({ id: "menu22" })}
                </Link>
              </p>
              <div className="bannerGradient--modules">
                <h1>
                  100 {intl.formatMessage({ id: "training0" })}
                  <br />
                  {content.module === "O4" && (
                    <>{intl.formatMessage({ id: "training2" })}</>
                  )}
                  {content.module === "O5" && (
                    <>{intl.formatMessage({ id: "training3" })}</>
                  )}
                  {content.module === "O6" && (
                    <>{intl.formatMessage({ id: "training4" })}</>
                  )}
                </h1>
                <div className="bannerGradient--badge">
                  <ModuleBadge
                    module={content.module}
                    source={"lessonBanner"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="content--fullwidth">
        <NavLessons
          grainId={content.grainId}
          module={content.module}
        />
        <div id="lessons__content" className="content--main lessons__container">
          <Toc
            grainId={content.grainId}
            notion={content.notion}
            module={content.module}
            colors={colors}
          />
          <section
            className="lessons__main"
            style={{ borderColor: `${colors.primary}` }}
          >
            <p
              className="lessons__number"
              style={{ color: `${colors.primary}` }}
            >
              {intl.formatMessage({ id: "training12" })} {content.grainId}
            </p>
            <h2 className="lessons__title">{content.name[intl.locale]}</h2>
            <div className="lessons__main__targetSkill">
              <h3 style={{ color: `${colors.primary}` }}>
                <span style={{ backgroundImage: `url(${colors.icon})` }}></span>
                {intl.formatMessage({ id: "training14" })}
              </h3>
              <div>{content.targetSkill[intl.locale]}</div>
            </div>
            <div>
              {content.type === "Multimedia" && (
                <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.content[intl.locale])) }}></div>
              )}
              {content.type === "Exercise" && (
                <div className="lessons__exercise">
                  <div className="lessons__exercise__exercise">
                    <h2>{intl.formatMessage({ id: "training21" })}</h2>
                    <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.exercise[intl.locale])) }}></div>
                  </div>
                  <div className="lessons__exercise__resources">
                    <h2>{intl.formatMessage({ id: "training22" })}</h2>
                    <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.resources[intl.locale])) }}></div>
                  </div>
                  <div className="lessons__exercise__correction">
                    <h2>{intl.formatMessage({ id: "training23" })}</h2>
                    <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.correction[intl.locale])) }}></div>
                  </div>
                </div>
              )}
              {content.type === "Quiz" && (
                <div className="lessons__quiz">
                  {content.introduction[intl.locale] && (
                    <div className="lessons__quiz__introduction">
                      <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(content.introduction[intl.locale])) }}></div>
                    </div>
                  )}
                  <div>
                    {questions
                      .filter(question => question[6].length > 0)
                      .map((question, questionNbr) => (
                        <div
                          className="lessons_quiz__question"
                          key={`question${questionNbr}`}
                        >
                          <h3>{question[0]}</h3>
                          <form>
                            {question
                              .filter(
                                (input, index) =>
                                  index !== 0 &&
                                  index !== 6 &&
                                  index !== 7 &&
                                  input
                              )
                              .map((input, index) => (
                                <span key={index} className="quizProposition">
                                  <label>
                                    <input
                                      type="radio"
                                      className="radio"
                                      value={index}
                                      data-correct={question[6] - 1}
                                      data-questionnbr={questionNbr}
                                      name={`question${questionNbr}Answer`}
                                      id={`question${questionNbr}Answer${index}`}
                                      onClick={checkAnswer}
                                    />
                                    {input}
                                  </label>
                                </span>
                              ))}
                          </form>
                          <div
                            className="quizCorrect"
                            id={`question${questionNbr}Correct`}
                          >
                            <p>{intl.formatMessage({ id: "training20" })}</p>
                          </div>
                          <div
                            className="quizExplanation"
                            id={`question${questionNbr}Explanation`}
                          >
                            {intl.formatMessage({ id: "training19" })}
                            <br />
                            <div class="markdown" dangerouslySetInnerHTML={{ __html: formattingJson(HTMLEntities(question[7])) }}></div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}

              {isBrowser &&
              window.localStorage[content.module] &&
              JSON.parse(window.localStorage[content.module]).indexOf(
                Number(content.grainId)
              ) > -1 ? (
                <div className="modulecard__start">
                  <button
                    onClick={unmarkRead}
                    style={{
                      borderColor: `${colors.primary}`,
                      color: `${colors.primary}`,
                    }}
                  >
                    {intl.formatMessage({ id: "training16" })}
                  </button>
                </div>
              ) : (
                <div className="modulecard__start">
                  <button
                    onClick={markRead}
                    style={{
                      borderColor: `${colors.primary}`,
                      color: `${colors.primary}`,
                    }}
                  >
                    {intl.formatMessage({ id: "training15" })}
                  </button>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </Layout>
  )
}

export const grainElement = graphql`
  query($slug: String) {
    lessonsJson(fields: { slug: { eq: $slug } }) {
      module
      notion
      grainId
      name { en,fr,it,es,bg }
      contentType
      targetSkill { en,fr,it,es,bg }
      type
      content { en,fr,it,es,bg }
      introduction { en,fr,it,es,bg }
      questionQuantity
      questionsString { en,fr,it,es,bg }
      exercise { en,fr,it,es,bg }
      resources { en,fr,it,es,bg }
      correction { en,fr,it,es,bg }
      id
      fields {
        slug
      }
    }
  }
`
